module.exports = __webpack_public_path__ + "img/vehicle-options-black-mazda.959275da.png";